import React from 'react';
import { SubText } from 'components/common/fontElements';
import { Wrapper, Content, Illustration, HeaderText } from './DTErrorPage.styles';

const DTErrorPage = () => {
  return (
    <Wrapper>
      <Content>
        <Illustration src="/images/illustrations/gears.svg" alt="gears" />
        <HeaderText>Something went wrong!</HeaderText>
        <SubText>This tree path does not exist</SubText>
      </Content>
    </Wrapper>
  );
};

export default DTErrorPage;
